export const renderHTML = (content: any) => ({
  __html: content,
});
